/**
 * Azure Entra ID MSAL Configuration
 * Work Allocation System
 */

import { Configuration, LogLevel } from '@azure/msal-browser';

// Azure Entra ID Configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '50afddbb-12e3-4b1f-85b5-19d99f0ee34a',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || '72c490b4-b8a8-4d0c-9915-f6b23e15b7f5'}`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI || 'http://localhost:5173',
    postLogoutRedirectUri: import.meta.env.VITE_REDIRECT_URI || 'http://localhost:5173',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',  // persist across tabs & page refreshes — prevents forced re-login on every new tab / reload
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return;
        
        switch (level) {
          case LogLevel.Error:
            console.error('[MSAL]', message);
            break;
          case LogLevel.Warning:
            console.warn('[MSAL]', message);
            break;
          case LogLevel.Info:
            console.info('[MSAL]', message);
            break;
          case LogLevel.Verbose:
            console.debug('[MSAL]', message);
            break;
        }
      },
      logLevel: LogLevel.Info,
    },
  },
};

// Login request scopes - Standard Microsoft Graph permissions
export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
  prompt: 'select_account' as const,
};

// API request scopes
export const apiRequest = {
  scopes: ['User.Read'],
};

// Microsoft Graph API endpoints
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphMePhotoEndpoint: 'https://graph.microsoft.com/v1.0/me/photo/$value',
};
